
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders/[[...slug]]",
      function () {
        return require("private-next-pages/orders/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orders/[[...slug]]"])
      });
    }
  